module.exports = __webpack_public_path__ + "img/overseasimage.b9367b3d.png";